import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../../../../scripts/jobCompletion";
import { reloadWithTurbo } from "../../../../scripts/turboHelper";

export default class CompanyBillingAccountController extends Controller {
    static targets = [
        "form",
        "submitButton"
    ];

    static values = {
        getJobUrl: String
    };

    readonly formTarget!: HTMLElement;
    readonly hasFormTarget!: boolean;
    readonly submitButtonTarget!: HTMLButtonElement;
    readonly getJobUrlValue!: string;

    connect() {
        if (this.hasFormTarget) {
            formSubmitWithWaitForJobCompletion(
                $(this.formTarget),
                $(this.submitButtonTarget),
                this.getJobUrlValue,
                () => {
                    reloadWithTurbo();
                }
            );
        }
    }
}
